import { useCallback, useState } from 'react'

export interface UseGHSAuthoringAssistantReturn {
    isOpen: boolean
    toggle: () => void
    open: () => void
    close: () => void
}

export const useGHSAuthoringAssistant = (): UseGHSAuthoringAssistantReturn => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = useCallback(() => {
        setIsOpen((prev) => !prev)
    }, [])

    const open = useCallback(() => {
        setIsOpen(true)
    }, [])

    const close = useCallback(() => {
        setIsOpen(false)
    }, [])

    return {
        isOpen,
        toggle,
        open,
        close,
    }
}
